
export enum OrderTabs {
  new = 'new',
  completed = 'completed',
}